import React from "react";
import { createHashRouter, RouterProvider, Outlet } from "react-router-dom";
//Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Search from "./pages/Search";
import { Toaster } from "sonner";
//Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Checkout from "./pages/Checkout";
//Layout
const Layout = () => {
  return (
    <div>
       <Toaster position="top-right" richColors />
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};
const router = createHashRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/products/:id", element: <Products /> },
      { path: "/product/:id", element: <ProductDetails /> },
      { path: "/search", element: <Search /> },
      {path: "/checkoutform", element:<Checkout/>}
    ],
  },
]);
const App = () => {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
